export default "__VITE_ASSET__BY3aXen6__"